import React from "react";

export default function AlarmClock(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="25"
            height="25"
            {...props}
        >
            <path
                id="Tracé_20286"
                data-name="Tracé 20286"
                d="M19.477,10.918a9.247,9.247,0,0,0-8.4-9.2V0H9.4V1.723a9.219,9.219,0,0,0-5.931,15.46L1.848,18.961l1.243,1.13,1.624-1.783a9.168,9.168,0,0,0,11.046,0l1.624,1.786,1.243-1.13-1.619-1.779a9.2,9.2,0,0,0,2.468-6.267Zm-9.238,7.559A7.559,7.559,0,1,1,17.8,10.918,7.559,7.559,0,0,1,10.238,18.477Z"
                transform="translate(-0.174 0)"
            />
            <path
                id="Tracé_20287"
                data-name="Tracé 20287"
                d="M4.641,1.475,3.745.056A12.741,12.741,0,0,0,.017,3.378l1.4.931A11.039,11.039,0,0,1,4.641,1.475Z"
                transform="translate(-0.017 -0.009)"
            />
            <path
                id="Tracé_20288"
                data-name="Tracé 20288"
                d="M21.7,4.309l1.4-.931A12.741,12.741,0,0,0,19.373.056l-.9,1.419A11.039,11.039,0,0,1,21.7,4.309Z"
                transform="translate(-2.973 -0.009)"
            />
            <path
                id="Tracé_20289"
                data-name="Tracé 20289"
                d="M11,7v4.547l2.766,2.766,1.188-1.188L12.68,10.852V7Z"
                transform="translate(-1.776 -1.121)"
            />
        </svg>
    );
}
